import { Buttons, DataBrowsing } from '@platform/shared/ui';
import { MetadataTypes, ProjectTypes } from '@platform/types';
import React, { useState } from 'react';
import { useWorkspaceContext } from '../../../contexts/WorkspaceContext';
import * as peApi from '../../../pe.api';
import { getShadedWorkingLayer } from '../Edit/SocialExplorer/utils';

const { DataBrowser } = DataBrowsing;

interface Props {
  onSelect: (workingLayers: ProjectTypes.SocialExplorerWorkingLayer[]) => void;
  onCancel: () => void;
}

const SocialExplorer: React.FC<Props> = ({ onSelect, onCancel }) => {
  const { activeWorkspace } = useWorkspaceContext();
  const [isLoading, setIsLoading] = useState(false);

  const [selection, setSelection] = useState<{
    variableSelection: ProjectTypes.VariableSelection[];
    tableMetadata: MetadataTypes.Table;
    surveyMetadata: MetadataTypes.Survey;
  } | null>(null);

  const handleVariableSelection = (
    variableSelection: ProjectTypes.VariableSelection[],
    tableMetadata: MetadataTypes.Table,
    surveyMetadata: MetadataTypes.Survey
  ) => setSelection({ variableSelection, tableMetadata, surveyMetadata });

  const handleAddLayer = async () => {
    if (!selection) return;
    try {
      setIsLoading(true);

      const updatedLayer = await getShadedWorkingLayer({
        surveyName: selection.surveyMetadata.name,
        datasetAbbreviation: selection.variableSelection[0].datasetAbbrev,
        variableSelection: selection.variableSelection.map((x) => ({
          universeVariableId: x.universeVariableUuid,
          variableId: x.variableGuid,
          tableId: x.tableGuid,
        })),
      });

      onSelect([updatedLayer]);
    } catch {
      // TODO:
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className="w-full px-6 py-4">
        <div className="h-[500px]">
          <DataBrowser
            surveysApi={peApi.getSurveys}
            onChange={handleVariableSelection}
            activeWorkspaceId={activeWorkspace.id}
            selection={selection?.variableSelection ?? []}
            allowMultiSelection={false} // TODO: enable when possible
          />
        </div>
      </div>
      <div className="flex w-full items-center justify-end gap-2 border-t px-6 pt-3">
        <Buttons.Secondary onClick={onCancel}>Cancel</Buttons.Secondary>
        <Buttons.Primary onClick={handleAddLayer} disabled={!selection || isLoading} className="w-28 px-6">
          Add
        </Buttons.Primary>
      </div>
    </>
  );
};

export default SocialExplorer;
